/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ProductUploadHistoryItemDTOFromJSON, ProductUploadHistoryItemDTOToJSON, } from './ProductUploadHistoryItemDTO';
/**
 * Check if a given object implements the PaginatedResponseProductUploadHistoryItemDTO interface.
 */
export function instanceOfPaginatedResponseProductUploadHistoryItemDTO(value) {
    return true;
}
export function PaginatedResponseProductUploadHistoryItemDTOFromJSON(json) {
    return PaginatedResponseProductUploadHistoryItemDTOFromJSONTyped(json, false);
}
export function PaginatedResponseProductUploadHistoryItemDTOFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'currentPage': json['currentPage'] == null ? undefined : json['currentPage'],
        'totalCount': json['totalCount'] == null ? undefined : json['totalCount'],
        'items': json['items'] == null ? undefined : (json['items'].map(ProductUploadHistoryItemDTOFromJSON)),
    };
}
export function PaginatedResponseProductUploadHistoryItemDTOToJSON(json) {
    return PaginatedResponseProductUploadHistoryItemDTOToJSONTyped(json, false);
}
export function PaginatedResponseProductUploadHistoryItemDTOToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'currentPage': value['currentPage'],
        'totalCount': value['totalCount'],
        'items': value['items'] == null ? undefined : (value['items'].map(ProductUploadHistoryItemDTOToJSON)),
    };
}
